var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"grabbed-layer-view",style:(_vm.nodeStyle)},[(_vm.treeNode.data.layerType == 'group')?_c('GroupLayerView',{attrs:{"treeNode":_vm.treeNode}}):_c('SingleLayerView',{attrs:{"treeNode":_vm.treeNode}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }